module.exports = __webpack_public_path__ + "static/media/face.7ed9f164.png";